import { render, staticRenderFns } from "./BaseShopDetails.vue?vue&type=template&id=a855224c&scoped=true&"
import script from "./BaseShopDetails.vue?vue&type=script&lang=js&"
export * from "./BaseShopDetails.vue?vue&type=script&lang=js&"
import style0 from "./BaseShopDetails.vue?vue&type=style&index=0&id=a855224c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a855224c",
  null
  
)

export default component.exports